import { Divider, Flex, Grid, GridItem, Heading, Text } from "@chakra-ui/react";
import { translateSubElementString } from "../../../../../../utils";
import { Card } from "../../../../../../components/Card";
import * as React from "react";
import { useTranslation } from "react-i18next";
import GroupRows from "./GroupRows";

function RatiosSection({ data }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage"
  });

  const ratiosItems = [{
    label: t("metrics.locationBased"),
    value: data.carbonIntensityRatioGrossLocationBased
  }, {
    label: t("metrics.marketBased"),
    value: data.carbonIntensityRatioGrossMarketBased
  }];

  const inflationItems = [{
    label: t("metrics.locationBased"),
    value: data.inflationAdjustedIntensityRatioGrossLocationBased
  }, {
    label: t("metrics.marketBased"),
    value: data.inflationAdjustedIntensityRatioGrossMarketBased
  }];

  return (
    <Card boxShadow="xs">
      <Heading size="md" marginBlock="1">
        {t("ratios")}
      </Heading>
      <Divider marginBlock={5} />
      <Grid templateColumns="repeat(2, 1fr)" gap={2} overflow="auto">
        <GridItem></GridItem>
        <GridItem>
          <Heading size="sm" marginBlock="1" align="right">
            {translateSubElementString("reportsPage.totalEmissionsGross")}
          </Heading>
        </GridItem>

        <GridItem>
          <Flex>
            <Text
              display="flex"
              justifyContent="center"
              alignItems="center"
              fontSize="sm"
              fontWeight="bold">
              {t("metrics.carbonIntensityRatio")}
            </Text>
          </Flex>
        </GridItem>
        <GridItem></GridItem>

        <GroupRows items={ratiosItems} itemsType={"ratio"} />

        <GridItem>
          <Flex>
            <Text
              display="flex"
              justifyContent="center"
              alignItems="center"
              fontSize="sm"
              fontWeight="bold">
              {t("metrics.inflationAdjustedIntensityRatio")}
            </Text>
          </Flex>
        </GridItem>
        <GridItem></GridItem>

        <GroupRows items={inflationItems} itemsType={"inflation"} />
      </Grid>
    </Card>
  );
}

export default RatiosSection;